import Multiselect from './src/Multiselect.vue'

export * from './src'

export default Multiselect
